<div class="get-care-now-title-container-web">{{title}}</div>
<div class="get-care-now-description-container-web" style="max-width: 442px;">
    <div>{{description}}</div>
</div>
<div *ngIf="virtualUrgentCareOptions != null && virtualUrgentCareOptions.length > 0" class="get-care-now-scroll-container-web">
    <app-virtual-urgent-care-option-card
      *ngFor="let option of virtualUrgentCareOptions"
      [providerId]="option.providerId"
      [specialtyId]="option.specialtyId"
      [specialties]="option.specialties"
      [name]="option.providerName"
      [photo]="option.photo"
      [availability]="option.nextAvailability">
    </app-virtual-urgent-care-option-card>
</div>
<div *ngIf="virtualUrgentCareOptions != null && virtualUrgentCareOptions.length > 0" style="align-items: center; justify-content: center; display: flex; padding: 24px;">
  <button mat-button class="action-button-secondary" style="border-radius: 12px;" (click)="showMeMore()">{{showMoreText}}</button>
</div>
<div *ngIf="!virtualUrgentCareOptions || virtualUrgentCareOptions.length === 0" style="width: 190px; height:190px; margin-top: 16px; margin-left: 16px;">
    <ng-container>
        <div class="get-care-now-loading-spinner-mobile">
            <mat-spinner></mat-spinner>
        </div>
    </ng-container>
</div>